

























































































import moment from "moment";
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  filters: {
    moment(value: string, format: string) {
      if (value == "") {
        return "---";
      }
      return moment(value).format(format);
    },
    days(value: string) {
      if (value == "") {
        return "詳細";
      }
      const now = moment(new Date()).format("YYYY-MM-DD");
      const d = moment(value).diff(moment(now), "days");
      return  `受講する(あと${d}日で終了)`;
    }
  }
})
export default class AttendanceTable extends Vue {
  @Prop() title?: string;
  @Prop() rows?: [];
  @Prop() status?: string;

  isBeforeStart(from: string): boolean {
    return moment().isBefore(moment(from, "YYYY/MM/DD"));
  }

  // 詳細を表示する
  clickDetails(id: string) {
    this.$router.push({ name: 'AttendanceDetails', params: { id: id } });
  }
}
